import {
  BLOOD_PRESSURE_DIASTOLIC,
  BLOOD_PRESSURE_SYSTOLIC,
} from "$routes/_lib/constants";
import InvestigationResults from "$routes/patient/[:patientId]/_lib/investigations/dynamic-investigation-results/investigation-results";
import InvestigationActivityCard from "$routes/patient/[:patientId]/_lib/investigations/investigation-activity-card";
import { Grid } from "@material-ui/core";
import { partition } from "ramda";

const systolicNames = [BLOOD_PRESSURE_SYSTOLIC, "BP - Systolic"];

function mapTestResult(data, systolic) {
  const { name, displayName, value, unit } = data;
  if ([BLOOD_PRESSURE_DIASTOLIC, "BP - Diastolic"].includes(name)) {
    return [{ title: "Blood Pressure" }, `${systolic}/${value}`];
  }

  // Use <pre> so that newlines are respected
  if (data.name?.toLowerCase() === "notes") {
    return [{ title: "Notes" }, <pre>{value}</pre>];
  }

  return [{ title: displayName || name }, `${value} ${unit || ""}`];
}

const Investigation = ({ testResult }) => {
  if (!testResult?.results?.length) return null;

  const { created } = testResult.meta;
  return testResult.results.map((result) => {
    if (!result.result?.length) return null;

    const [systolicResults, nonSystolicResults] = partition(
      (item) => systolicNames.includes(item.name),
      result.result,
    );

    const lastSystolic = systolicResults[systolicResults.length - 1];

    const items = nonSystolicResults.map((item) =>
      mapTestResult(item, lastSystolic?.value),
    );

    return (
      <InvestigationActivityCard
        title={result.name}
        fulfilledDate={created}
        fulfiller={" "} // HACK: testResults do not contain the name of who fulfilled
        key={`${testResult.uuid}-${result.investigation}`}
      >
        <Grid container spacing={1} justifyContent="space-between">
          <InvestigationResults items={items} />
        </Grid>
      </InvestigationActivityCard>
    );
  });
};

export default Investigation;
